// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1lmqies0 {
  padding: var(--_18w76bwc);
  text-align: center;
  cursor: pointer;
  line-height: var(--_18w76bw3w);
}
._1lmqies0:hover {
  color: var(--_18w76bw29);
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B","sourcesContent":["._1lmqies0 {\n  padding: var(--_18w76bwc);\n  text-align: center;\n  cursor: pointer;\n  line-height: var(--_18w76bw3w);\n}\n._1lmqies0:hover {\n  color: var(--_18w76bw29);\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
